/*
	HeaderNotifications.tsx -- A component for the header bar to create a notification dropdown.
*/
import { DropdownItem, DropdownItemClickType, IconDropdownButton } from 'Components/Buttons/DropdownButton';
import { ICON_NOTIFICATION } from 'Config/Icons';
import { sortNotifications } from 'Helpers/Compare';
import { iso8601ToUsDateShort } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { getNotificationDisplayNameWithFeature } from 'Helpers/NotificationFormatter/NotificationFormatter';
import { getNotificationUrl } from 'Helpers/URLBuilder/URLBuilder';
import { UserNotification } from 'Models/Notification';

export interface HeaderNotificationProps {
    notifications: UserNotification[];
}

export const HeaderNotifications = (props: HeaderNotificationProps) => {
    /**
     * Given a list of Notifications, sort/format them into items appropriate for a drop-down menu.
     */
    const convertNotificationsToDropdownItems = (notifications: UserNotification[]): DropdownItem[] => {
        const currentTimestamp = new Date();
        const dropdownItems: DropdownItem[] = sortNotifications(notifications).map((notification: UserNotification) => {
            const overdueText = new Date(notification.due_date) < currentTimestamp ? ' (OVERDUE)' : '';
            return {
                _type: DropdownItemClickType.HYPERLINK,
                text: `${getNotificationDisplayNameWithFeature(notification)} due ${iso8601ToUsDateShort(notification.due_date)}${overdueText}`,
                href: getNotificationUrl(notification),
            };
        });

        return dropdownItems;
    };

    return <IconDropdownButton badgeColor="blue" badgeVariant="standard" dropdownItems={convertNotificationsToDropdownItems(props.notifications)} emptyText="No Notifications" header="Due Within Two Weeks" icon={ICON_NOTIFICATION} />;
};
